import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const modulesFiles = import.meta.glob('./modules/*.js', { eager: true });

const modules = Object.keys(modulesFiles).reduce((modulesvalue, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/modules\/(.*)\.js$/, '$1');
  const value = modulesFiles[modulePath];
  modulesvalue[moduleName] = value.default;
  return modulesvalue;
}, {});

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [
    createPersistedState({
      storage: window.localStorage
    })
  ]
});

export default store;